// =============================================
// Globale Konfiguration (export für ES-Module)
// =============================================

export const AppConfig = {
    features: {
        useLazyLoadingForCategories: true,
        useVirtualScrolling: false,
        enableDebugLogging: false,
        enableDrilldownParallelOps: true,
        enableDrilldownUnboundedQuery: false,
        drilldownInitialLimit: 500,
        drilldownRetryLimit: 250,
        drilldownCacheTtlMs: 30000,
        enableCategoryToggleSingleRefresh: true,
        enableMappingBatchSave: true,
        enableMappingOptimisticAddColumn: true,
        enableMappingPagination: true,
        enableMappingPaginationPrefetch: true,
    },
    performance: {
        autoLazyLoadingThreshold: 2,
        categoryLoadConcurrency: 6,
        mappings: {
            modalPageSize: 200,
            saveConcurrency: 8,
            maxBatchRowsPerRequest: 500,
            budgetModalOpenP95Ms: 800,
            budgetSingleCellSaveP95Ms: 250,
            budgetBulkSaveP95Ms: 1500,
            maxBackgroundPagesPerTick: 1
        }
    },
    api: {
        timeout: 60000,
    }
};
